/*eslint @typescript-eslint/no-unused-vars: "off"*/
/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface FormResponseValueUpdate
 */
export interface FormResponseValueUpdate {
    /**
     * 
     * @type {string}
     * @memberof FormResponseValueUpdate
     */
    source_question_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FormResponseValueUpdate
     */
    source_response_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FormResponseValueUpdate
     */
    update_response_source?: FormResponseValueUpdateUpdateResponseSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof FormResponseValueUpdate
     */
    value: string;
}




/**
* @export
* @enum {string}
*/
export enum FormResponseValueUpdateUpdateResponseSourceEnum {
    ANSWERLOOKUPLENSES = 'ANSWER_LOOKUP_LENSES',
    AUTOCOMPLETE = 'AUTOCOMPLETE',
    MANUAL = 'MANUAL',
    MERGE = 'MERGE'
}


